module.exports = __webpack_public_path__ + "static/media/Brigitte Schmittlein.6cf357a9.JPG";